import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Button } from '@/components/ui/Button';
import { PhotoGrid } from '@/components/ui/PhotoGrid';
import { useApplyToListing, useListing } from '@/hooks/useListings';
import { formatCurrency } from '@/utils/format';

export function ListingDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const listing = useListing(id ? Number(id) : null);
  const apply = useApplyToListing();
  const [message, setMessage] = useState('');
  const [applied, setApplied] = useState(false);

  if (listing.isLoading) return <Spinner />;
  if (!listing.data) return null;

  const submit = async () => {
    await apply.mutateAsync({ id: listing.data!.id, message });
    setApplied(true);
  };

  return (
    <Card title={listing.data.title}>
      <PhotoGrid
        photos={listing.data.photos
          .map((p) => p.url)
          .filter((u): u is string => Boolean(u))}
      />
      <p className="mt-3 text-sm text-slate-600">{listing.data.address}</p>
      <p className="mt-1 text-lg font-semibold text-brand">
        {formatCurrency(listing.data.monthly_rate)}
      </p>
      <p className="mt-3 text-sm">{listing.data.description}</p>

      {applied ? (
        <p className="mt-4 text-sm text-green-700">{t('applications.applied')}</p>
      ) : (
        <div className="mt-4 space-y-2">
          <textarea
            rows={3}
            placeholder={t('applications.message_placeholder')}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
          />
          <Button onClick={() => void submit()} loading={apply.isPending}>
            {t('applications.apply')}
          </Button>
        </div>
      )}
    </Card>
  );
}
